import { createSlice, type PayloadAction } from '@reduxjs/toolkit';

import type { CommonListAppState } from '../../common_list/types';
import type {
  ActivePerson,
  AssetFaceRecognitionPanelAppState,
  PersonsStatusFilters,
} from './types';

export const assetPersonsInitialState: CommonListAppState = {
  ids: [],
  pagination: {
    page: 1,
    pages: 1,
    total: 0,
    per_page: 0,
  },
  sort: [
    {
      name: 'date_created',
      order: 'desc',
    },
  ],
  loading: false,
};

export const assetFaceRecognitionPanelInitialState: AssetFaceRecognitionPanelAppState =
  {
    inConfirmationMode: false,
    hasShowBoundingBoxesToggledOn: true,
    personsStatusFilters: {
      unconfirmed: true,
      new: true,
      confirmed: true,
    },
    assetVersionIdsWithConfirmationModeShown: [],
  };

export const assetFaceRecognitionPanelSlice = createSlice({
  name: 'asset_face_recognition',
  initialState: assetFaceRecognitionPanelInitialState,
  reducers: {
    setInConfirmationMode: (state, action: PayloadAction<boolean>) => {
      state.inConfirmationMode = action.payload;
    },
    setActivePerson: (state, action: PayloadAction<ActivePerson>) => {
      state.activePerson = action.payload;
    },
    toggleShowBoundingBoxes: (
      state,
      action: PayloadAction<boolean | undefined>,
    ) => {
      state.hasShowBoundingBoxesToggledOn = action.payload;
      state.activePerson = undefined;
    },
    setPersonsStatusFilters: (
      state,
      action: PayloadAction<PersonsStatusFilters>,
    ) => {
      Object.assign(state.personsStatusFilters, action.payload);
    },
    setHasConfirmationModeShown: (state, action: PayloadAction<string>) => {
      state.assetVersionIdsWithConfirmationModeShown.push(action.payload);
    },
  },
});

export const {
  setInConfirmationMode,
  setActivePerson,
  toggleShowBoundingBoxes,
  setPersonsStatusFilters,
  setHasConfirmationModeShown,
} = assetFaceRecognitionPanelSlice.actions;

export const assetFaceRecognitionPanelReducer =
  assetFaceRecognitionPanelSlice.reducer;
